import React, { useEffect, useState } from "react";
import { MdOutlineAddAPhoto } from "react-icons/md";
import { Link } from "react-router-dom";
import DashboardFooter from "./DashboardFooter";
import { splitStringByDash } from "../../utils/splitStringByComma";
import { useSelector } from "react-redux";

type VerifyProp = {
  refetch?: any;
};

const Verify: React.FC<VerifyProp> = ({ refetch }) => {
  const [selectedDay, setSelectedDay] = useState<string>("");
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [selectedYear, setSelectedYear] = useState<string>("");

  const user = useSelector((state: any) => state.user.userDetails);

  // console.log(user);
  const idData = JSON.parse(user?.userDriverKYC);
  // console.log(idData);
  const dob = splitStringByDash(idData?.id_info?.birth_date);
  // console.log(dob);

  const months = [
    { name: "January", days: 31 },
    { name: "February", days: 28 }, // Default to 28 days
    { name: "March", days: 31 },
    { name: "April", days: 30 },
    { name: "May", days: 31 },
    { name: "June", days: 30 },
    { name: "July", days: 31 },
    { name: "August", days: 31 },
    { name: "September", days: 30 },
    { name: "October", days: 31 },
    { name: "November", days: 30 },
    { name: "December", days: 31 },
  ];
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) =>
    (currentYear - i).toString()
  );

  // Update the available days whenever the selected month changes
  useEffect(() => {
    const selectedMonthDays = calculateDaysInMonth(selectedMonth, selectedYear);
    if (+selectedDay > selectedMonthDays) {
      setSelectedDay("");
    }
  }, [selectedMonth, selectedYear]);

  // Generate an array of days based on the selected month and year
  const generateDays = () => {
    const selectedMonthDays = calculateDaysInMonth(selectedMonth, selectedYear);
    return Array.from({ length: selectedMonthDays }, (_, i) =>
      (i + 1).toString()
    );
  };

  // Calculate the number of days in a month, considering leap years
  const calculateDaysInMonth = (month: string, year: string) => {
    const monthData = months.find((m) => m.name === month);
    if (monthData) {
      const isLeapYear =
        (parseInt(year) % 4 === 0 && parseInt(year) % 100 !== 0) ||
        parseInt(year) % 400 === 0;
      return isLeapYear && monthData.name === "February" ? 29 : monthData.days;
    }
    return 31; // Default to 31 days if the month is not found
  };

  useEffect(() => {
    // refetch();
  });

  return (
    // <div className=" h-full w-[90%] pt-20 flex flex-col items-end">
    //   <p className=" font-Jakarta text-[20px] text-midGreen font-bold ">
    //     Complete your profile to start hiring your car out or lease vehicles
    //   </p>
    //   <Link
    //     to="/kyc"
    //     className="cursor-pointer bg-midGreen font-medium text-white text-center border rounded-xl text-[15px] p-4 font-Jakarta w-[15%]"
    //   >
    //     <button type="button">Proceed</button>
    //   </Link>
    // </div>
    <div className="w-full bg-[#F6F7F9] py-20  ">
      <div className="w-[90%] mx-auto border border-[#b9b9b9] bg-white rounded-xl lg:rounded-3xl ">
        <div className="flex flex-col p-7 gap-[50px]">
          <div className="px-10 py-5 border-l border-l-[#E98529] bg-[#F4F4F4] text-black font-Poppins font-normal text-[12px] lg:text-[20px]  leading-4 lg:leading-7 ">
            Some of these information would appear on your profile when you send
            them a booking request. If you publish a car listing, your profile
            becomes public so that drivers can access a recap of your reviews.
          </div>
          {/* <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[12px] lg:text-[20px] leading-4 lg:leading-7 ">
                Your photo
              </p>
              <span className="w-[80%] border-t border-[#EBE1EB] "></span>
            </div>
            <div className="flex flex-col gap-[10px] w-fit  ">
              <p className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Picture{" "}
              </p>
              <div className="flex flex-col p-7 bg-[#D9D9D9A8] border rounded-lg cursor-pointer gap-5 justify-center items-center ">
                <MdOutlineAddAPhoto size={30} color="black" />
                <p className="text-black font-Poppins font-medium text-[8px] lg:text-[12px]">
                  Add a photo
                </p>
              </div>
            </div>
          </div> */}
          <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[12px] lg:text-[20px] leading-4 lg:leading-7 ">
                Personal Information
              </p>
              <span className="w-[80%] border-t border-[#EBE1EB] "></span>
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Last name
              </label>
              <input
                readOnly
                type="text"
                value={user.lastName}
                placeholder="Last name"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                First name
              </label>
              <input
                readOnly
                type="text"
                value={user.firstName}
                placeholder="First name"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Birth date
              </label>
              {/* <input
              readOnly
                type="date"
                placeholder="Birth date"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              /> */}
              <div className="w-full flex justify-between items-center">
                {/* Year Dropdown */}
                <div className="w-[30%] px-3 py-3 border border-[#ccc] rounded-lg outline-none">
                  {dob[0] ?? "Year"}
                </div>

                {/* Month Dropdown */}
                <div
                  // onChange={(e) => setSelectedMonth(e.target.value)}
                  className="w-[30%] px-3 py-3 border border-[#ccc] rounded-lg outline-none"
                >
                  {dob[1] ?? "Month"}
                </div>

                {/* Day Dropdown */}
                <div
                  // onChange={(e) => setSelectedDay(e.target.value)}
                  className="w-[30%] px-3 py-3 border border-[#ccc] rounded-lg outline-none"
                >
                  {dob[2] ?? "Day"}
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Gender
              </label>
              <input
                readOnly
                type="text"
                value={idData?.id_info?.gender}
                placeholder="Gender"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>
          </div>

          <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[12px] lg:text-[20px] leading-4 lg:leading-7 ">
                Contact
              </p>
              <span className="w-[80%] border-t border-[#EBE1EB] "></span>
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Email
              </label>
              <input
                readOnly
                type="email"
                value={user.email}
                placeholder="e.g: user@mail.com"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>

            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                SMS notifications will be sent to:
              </label>
              <input
                readOnly
                type="tel"
                pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                placeholder="e.g: (555) 555-1234"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
              <span className="text-[#585656] font-Poppins text-[7px] lg:text-[10px] font-medium">
                Only owners that you contact can see your phone number
              </span>
            </div>
          </div>
          <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[12px] lg:text-[20px] leading-4 lg:leading-7 ">
                Address Information
              </p>
              <span className="w-[80%] border-t border-[#EBE1EB] "></span>
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Address
              </label>
              <input
                readOnly
                type="text"
                value={idData?.id_info?.address.full_address}
                placeholder="Address"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Additional to address
              </label>
              <input
                readOnly
                type="text"
                placeholder="Additional to address"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>

            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Postal code and city
              </label>
              <input
                readOnly
                type="text"
                value={
                  idData?.id_info?.address.parsed_address.address_zip_code +
                  " " +
                  idData?.id_info?.address.parsed_address.address_city
                }
                placeholder="Postal code and city"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Country
              </label>
              <input
                readOnly
                type="text"
                value={
                  idData?.id_info?.address.parsed_address.address_country ??
                  idData?.id_info?.issue_country
                }
                placeholder="Country"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                State
              </label>
              <input
                readOnly
                type="text"
                value={idData?.id_info?.address.parsed_address.address_state}
                placeholder="State"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>
          </div>
          <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[12px] lg:text-[20px] leading-4 lg:leading-7 ">
                Additional details
              </p>
              <span className="w-[80%] border-t border-[#EBE1EB] "></span>
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                About me
              </label>
              <textarea
                placeholder="About me"
                className="border border-[#ccc] rounded-lg w-full h-[250px] outline-none p-5"
              />
              <span className="text-[#585656] font-Poppins text-[7px] lg:text-[10px] font-medium">
                These details enable the owner to get to know you a bit better.
                The information you provide, the more likely you are to rent.
              </span>
            </div>
          </div>
          <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <span className="w-full border-t border-[#EBE1EB] "></span>
            </div>
            <div className="flex flex-col gap-[10px] w-fit ">
              <button
                type="button"
                className="bg-darkGreen font-bold text-white text-center border rounded-xl text-[15px] py-4 px-12 font-Poppins"
              >
                Update my profile
              </button>
            </div>
          </div>
        </div>
      </div>
      <DashboardFooter />
    </div>
  );
};

export default Verify;
